module.exports = __webpack_public_path__ + "c4a3c6075d50d39d865bce63208ed0d4.svg";